import { BrowserRouter as Router } from "react-router-dom";

import { CssBaseline, ThemeProvider } from "@mui/material";

import { createBrowserHistory } from "history";

import { globalStyles } from "Shared/styles/global";
import theme from "Shared/styles/theme";

import Routes from "../Router/routes";

function App() {
  const history = createBrowserHistory();

  return (
    <ThemeProvider theme={theme}>
      {globalStyles}
      <CssBaseline />
      <Router history={history}>
        <Routes />
      </Router>
    </ThemeProvider>
  );
}

export default App;
